import React, { Component } from 'react';
// import classnames from 'classnames';

// import Button from '../Button';

import checkClickInside from '../utils/checkClickInside';
// import styles from './editable-text.styl';

/**
 * Component for text block which can be edited
 * @params props:
 *  defaultValue - string of contained text
 *  placeholder - default value of component when defaultValue is empty or undefined
 *  onTextUpdate - func callback for submit changes
 *  className - string of classes for text
 *  required - bool parameter for highlighting placeholder
 */
export default class EditableText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      value: props.defaultValue,
    };
    this.classMarker = 'editable-text';

    this.onTextChange = this.onTextChange.bind(this);
    this.onUpdateText = this.onUpdateText.bind(this);
    this.onTextClick = this.onTextClick.bind(this);
    this.onTextBlur = this.onTextBlur.bind(this);
  }

  onTextChange(e) {
    this.setState({ value: e.target.value });
  }

  onUpdateText() {
    this.props.onTextUpdate(this.state.value);
    document.removeEventListener('click', this.onTextBlur);
    this.setState({ isEdit: false });
  }

  onTextClick() {
    document.addEventListener('click', this.onTextBlur);
    this.setState({ isEdit: true });
  }

  onTextBlur(e) {
    if (!checkClickInside(e, this.classMarker)) {
      document.removeEventListener('click', this.onTextBlur);
      this.setState({ isEdit: false });
    }
  }

  renderEditState() {
    return (
      <div>
        <textarea
          value={this.state.value}
          onChange={this.onTextChange}
          autoFocus="1"
          placeholder={this.props.placeholder}
        />
        <span>
          <button className="btn btn-bright" onClick={this.onUpdateText}>
            Update
          </button>
        </span>
      </div>
    );
  }

  renderSplitText() {
    const splitText = this.props.defaultValue.split('\n');
    return splitText.map((t, i) => (
      <div key={i}>
        {t || <br />}
      </div>
    ));
  }

  renderReadState() {
    return (
      <div
        onClick={this.onTextClick}
        // className={classnames(this.props.className, {
        //   [styles.placeholder]: !this.props.defaultValue,
        //   [styles.required]: this.props.required && !this.props.defaultValue,
        // })}
      >
        {this.props.defaultValue
          ? this.renderSplitText()
          : this.props.placeholder}
      </div>
    );
  }

  render() {
    return (
      <div className="editable-text">
        {this.state.isEdit
          ? this.renderEditState()
          : this.renderReadState()
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditableText.js